const globalStyles = theme => ({
    '@global': {
        html: {
            background: theme.palette.background.default,
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
            height: '100%',
        },
        body: {
            backgroundColor: '#f6f6f6',
            margin: 0,
            height: '100%',
        },
    },
});

export default globalStyles;



// WEBPACK FOOTER //
// ./src/config/globalStyles.js